// 备注，情报的组件不支持配置话，所以第一期只支持组件的显示隐藏
export const PAGE_CONFIG = {
  name: 'CommonLogWrap',
  config: {
    "logConfig": {
      "menuId": '',
      "pageId": "101901",
      "pageName": "Potential Market",
      "extInfo": "Potential Market",
      "pagePath": "/potentialMarket",
    },
  },
  children: [
    {
      name: 'PageWrap',
      children: [
        {
          name: 'SummaryService'
        },
        {
          name: 'TableService'
        }
      ]
    }
  ]
};
export const MOBILE_PAGE_CONFIG = {
  name: 'CommonLogWrap',
  config: {
    logConfig: {
      menuId: '',
      pageId: '101901',
      pageName: 'Potential Market - Mobile',
      extInfo: 'Potential Market - Mobile',
      pagePath: '/potentialMarket/mobile',
    },
  },
  children: [
    {
      name: 'MobileOverlapService',
    },
  ],
};
